export const personReportsSelector = state => {
  return state.personReports;
};
